import React, { Dispatch, SetStateAction } from "react";
import { IDeclaration } from "../../exports/interfaces";
import { dynamicSuccess } from "../../hooks/useToast";

const Declaration = ({
  declaration,
  setDeclaration,
}: {
  declaration: IDeclaration;
  setDeclaration: Dispatch<SetStateAction<IDeclaration>>;
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;

    setDeclaration((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  return (
    <div className="dashboard-card">
      <div className="row g-4">
        <div className="col-md-4">
          <label className="form-label">
            Name <span className="primary-color">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter name"
            name="name"
            value={declaration.name}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-4">
          <label className="form-label">
            Position <span className="primary-color">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter position"
            name="position"
            value={declaration.position}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-4">
          <label className="form-label">
            Mobile Number <span className="primary-color">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter mobile number"
            name="mobile"
            value={declaration.mobile}
            onChange={handleChange}
          />
        </div>

        <div className="col-12">
          <label className="form-label">
            Declaration <span className="primary-color">*</span>
          </label>

          <p className="text-muted small mb-2 fst-italic">
            Check all that apply.
          </p>

          <div className="table-checkbox d-flex align-items-center gap-2">
            <input
              type="checkbox"
              id="declaration"
              name="declaration"
              checked={declaration.declaration}
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="declaration">
              I hereby declare that the information provided is true and
              correct.
            </label>
          </div>
        </div>

        <div className="col-12 d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-badge-primary px-4"
            onClick={() => {
              localStorage.setItem("declaration", JSON.stringify(declaration));
              dynamicSuccess("Declaration saved as draft!");
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default Declaration;
